import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import logout from '~/helpers/logout-helper';
import logoutAppShop from '@/graphql/seller/logoutAppShop.gql';
export default {
  computed: {
    sellerName: function sellerName() {
      return this.$cookies.get('MDM_SELLER_USER_NAME');
    },
    formatSellerName: function formatSellerName() {
      if (this.sellerName && this.sellerName.trim().split(' ').length > 1) {
        var firstName = this.sellerName.split(' ')[0];
        var initial = this.sellerName.split(' ')[1][0];
        return "".concat(firstName, " ").concat(initial, ".");
      }

      return null;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    setSeller: 'seller/setSeller'
  })), {}, {
    goToShop: function goToShop() {
      window.location = this.$store.state.sharedEnv.payload.appShopUrl;
    },
    handleSellerLogOut: function handleSellerLogOut() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$apolloProvider.defaultClient.mutate({
                  mutation: logoutAppShop
                });

              case 3:
                _context.next = 5;
                return logout(_this.$store);

              case 5:
                _this.setSeller(null);

                window.location = _this.$store.state.sharedEnv.payload.appShopUrl;

                _this.goToShop();

                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                _this.$logger.error("LOGOUT_APP_SHOP_ERROR : ".concat(_context.t0));

                _this.$root.$emit('notification', {
                  message: _this.$t('error'),
                  type: 'error'
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }))();
    }
  })
};